export const styles = {
  textField: {
    '& .MuiInputBase-root': {
      paddingTop: '0',
      height: '36px',
      background: 'white',
      border: '1px solid #EDEFF7',
      borderRadius: '8px',
      outline: 'none',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderWidth: 0,
      },
      '&:hover fieldset': {
        borderWidth: 0,
      },
      '& fieldset': {
        borderWidth: 0,
      },
    },
  },
};
